import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Groups.css";

export default function Groups() {
  const [groupsHeader, setGroupsHeader] = useState([]);
  const [groupsImages, setGroupsImages] = useState([]);
  const [awardData, setAwardData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchImages = async () => {
      setLoading(true);
      try {
        const [groupsRes, awardRes] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_URL}/api/images/groups`),
          fetch(`${process.env.REACT_APP_API_URL}/api/images/main`),
        ]);

        if (!groupsRes.ok) {
          throw new Error(groupsRes.message || "Failed to fetch group images");
        }
        if (!awardRes.ok) {
          throw new Error(awardRes.message || "Failed to fetch award images");
        }

        const groupsData = await groupsRes.json();
        const awardData = await awardRes.json();

        setGroupsHeader(groupsData.data.header);
        setGroupsImages(groupsData.data.montage);
        setAwardData(awardData.data.award);
      } catch (err) {
        setError(err || "Failed to fetch images");
      } finally {
        setLoading(false);
      }
    };
    fetchImages();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Unable to load images.</div>;
  }

  if (!groupsHeader.length) return <div>No data</div>;
  return (
    <div className="groups">
      {/* Groups Header */}
      <section className="groups__intro--container">
        <div className="groups__intro--header">
          <img
            src={groupsHeader[0]?.src}
            alt={groupsHeader[0]?.alt}
            className="groups__intro--image"
          />
          <div className="groups__intro--text">
            <h1>Picnics For Groups</h1>
            <p>Luxury picnics designed for unforgettable group celebrations</p>
          </div>
          <div className="groups_award--container-right">
            <img
              src={awardData[2]?.src}
              alt={awardData[2]?.alt}
              className="groups__intro--image"
            />
          </div>
        </div>

        <div className="groups__intro--content">
          <h2> Group Picnics on Bribie Island</h2>
          <p>Relax - Celebrate - Unwind Island Style.</p>
          <p>
            Host your next gathering with a stunning picnic setup on beautiful
            Bribie Island. Whether it's a birthday, bridal shower, baby shower,
            or just because—our curated picnic experience brings effortless
            charm to your event.
          </p>
        </div>
      </section>

      {/* Group Details Option */}
      <section className="groups__container">
        <div className="groups__picnic--container">
          <div className="groups__picnic--image-container">
            {/* Image Placeholder */}
            <img
              className="groups__picnic--image"
              src={groupsImages[0]?.src}
              alt={groupsImages[0]?.alt}
            />
          </div>

          {/* Group Content */}
          <div className="groups__picnic--details">
            <div className="groups__picnic--header">
              <h2>Starting from $400 (covers up to 6 people)</h2>
            </div>
            <h2>Additional Guests $50 each.</h2>
            <h3>
              <strong>Group Picnic Inclusions</strong>
            </h3>
            <div className="groups__picnic--inclusions">
              <ul>
                <li>Low-lying picnic tables</li>
                <li>Rugs and plush cushions for cozy seating</li>
                <li>Tablecloths, runners & stylish table décor</li>
                <li>Artificial floral arrangements</li>
                <li>
                  Individual place settings: placemat, plate, gold cutlery,
                  cloth napkin
                </li>
              </ul>
              <ul>
                <li>
                  Glassware: tumbler + your choice of champagne or wine glass
                </li>
                <li>Picnic basket stocked with:</li>
                <li>
                  Wipes, Hand Sanitizer, Bottle Opener, Garbage Bags,
                  Tissues{" "}
                </li>
                <li>3 hours hire</li>
              </ul>
            </div>
            <div className="groups__picnic--details-other">
              <p>Want to stay longer?</p>
              <p>
                You're welcome to extend your picnic - just ask! Extra time -
                $50 per hour
              </p>
            </div>
            <div className="groups__picnic--options">
              <Link
                to="/additions"
                className="groups__picnic--options-btn my-btn"
              >
                Additions/Enhancements
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Group Images Montage */}
      <div className="groups__container">
        <section className="groups__montage--flex">
          <div className="groups__picnic--montage-container">
            <img
              src={groupsImages[1]?.src}
              alt={groupsImages[1]?.alt}
              className="groups__picnic--montage-image"
            ></img>
            <img
              src={groupsImages[2]?.src}
              alt={groupsImages[2]?.alt}
              className="groups__picnic--montage-image"
            ></img>
            <img
              src={groupsImages[3]?.src}
              alt={groupsImages[3]?.alt}
              className="groups__picnic--montage-image"
            ></img>
            <img
              src={groupsImages[4]?.src}
              alt={groupsImages[4]?.alt}
              className="groups__picnic--montage-image"
            ></img>
          </div>

          <div className="groups__picnic--montage-container">
            <img
              src={groupsImages[5]?.src}
              alt={groupsImages[5]?.alt}
              className="groups__picnic--montage-image"
            ></img>
            <img
              src={groupsImages[6]?.src}
              alt={groupsImages[6]?.alt}
              className="groups__picnic--montage-image"
            ></img>
            <img
              src={groupsImages[7]?.src}
              alt={groupsImages[7]?.alt}
              className="groups__picnic--montage-image"
            ></img>
            <img
              src={groupsImages[8]?.src}
              alt={groupsImages[8]?.alt}
              className="groups__picnic--montage-image"
            ></img>
          </div>

          <div className="groups__picnic--montage-container">
            <img
              src={groupsImages[9]?.src}
              alt={groupsImages[9]?.alt}
              className="groups__picnic--montage-image"
            ></img>
            <img
              src={groupsImages[10]?.src}
              alt={groupsImages[10]?.alt}
              className="groups__picnic--montage-image"
            ></img>
            <img
              src={groupsImages[11]?.src}
              alt={groupsImages[11]?.alt}
              className="groups__picnic--montage-image"
            ></img>
            <img
              src={groupsImages[12]?.src}
              alt={groupsImages[12]?.alt}
              className="groups__picnic--montage-image"
            ></img>
          </div>

          <div className="groups__picnic--montage-container">
            <img
              src={groupsImages[13]?.src}
              alt={groupsImages[13]?.alt}
              className="groups__picnic--montage-image"
            ></img>
            <img
              src={groupsImages[14]?.src}
              alt={groupsImages[14]?.alt}
              className="groups__picnic--montage-image"
            ></img>
            <img
              src={groupsImages[15]?.src}
              alt={groupsImages[15]?.alt}
              className="groups__picnic--montage-image"
            ></img>
            <img
              src={groupsImages[16]?.src}
              alt={groupsImages[16]?.alt}
              className="groups__picnic--montage-image"
            ></img>
          </div>
        </section>

        <section className="groups__montage--grid">
          {groupsImages
            .slice(1, 16)
            .filter((img) => img?.src)
            .map((image, index) => (
              <img
                key={index}
                src={image.src}
                alt={image.alt || "Group picnic image"}
                className="groups__montage--grid-image"
              />
            ))}
        </section>
      </div>
    </div>
  );
}
